<template lang='pug'>
    v-layout( row wrap )
        template( v-for='( routesGroup, groupName, idx ) in currentRoutes' )
            v-flex( xs12 )
                h1.headline.mb-2 {{ groupName }}
                v-divider
            v-flex( xs12 sm4 md3 lg2 :key='index' v-for='( route, index ) in routesGroup' )
                v-card( hover :style='route | style' )
                    v-card-title( :style='opacityStyle' )
                        h3.title.mt-3 {{ route | routeTitle }}
                    v-card-text.px-0( :style='opacityStyle' )
                        v-list( dense )
                            v-list-tile( color='accent' @click='submitList( route )' )
                                v-list-tile-title.body-2 Ver listado
                            v-list-tile( color='secondary' :key='indexChild' v-for='( routeChild, indexChild ) in route.children.filter( filterRoute )' @click='submit( routeChild )' )
                                v-list-tile-title.body-1 {{ routeChild | routeTitle }}
</template>

<script>
    export default {
        computed: {

            /**
             * 
             */
            currentRoutes () {
                return this.items.filter( this.filterRoute ).reduce( this.reduceRoutes, {} )
            },
        },
        data () {
            return {
                opacityStyle: {
                    background: 'rgba( 255, 255, 255, .81 )'
                }
            }
        },
        filters: {

            /**
             * 
             */
            style ( route ) {
                return {
                    backgroundImage : route.meta.image ? 'url(' + route.meta.image + ')' : '',
                    backgroundSize  : 'cover',
                }
            },

            /**
             * 
             */
            routeTitle ( route ) {
                return ( route.meta && route.meta.title ) || ''
            },
        },
        methods: {
            
            /**
             * 
             */
            filterRoute ( route ) {

                //
                const noParams  = route.path.indexOf( ':' ) < 0
                    , hasMeta   = route.meta != undefined

                //
                return hasMeta && noParams
            },

            /**
             * 
             */
            findRouteList ( route ) {

                //
                const noParams  = route.path.indexOf( ':' ) < 0
                    , hasList   = route.name.includes( '-list' )

                //
                return hasList && noParams
            },

            /**
             * 
             */
            reduceRoutes ( routes, curr ) {

                //
                const groupName = curr.meta.group || this.defaultGroup
                    , routeName = curr.path

                //
                return {
                    ...routes,
                    [ groupName ]: {
                        ...routes[ groupName ],
                        [ routeName ]: curr,
                    }
                }
            },

            /**
             * 
             */
            submit ( route ) {
                this.$router.push({ name: route.name })
            },

            /**
             * 
             */
            submitList ( route ) {

                //
                const routeChild = route.children.find( this.findRouteList )
                    , hasChild   = routeChild != undefined

                //
                if ( hasChild ) {
                    this.$router.push({ name: routeChild.name })
                }
            },
        },
        props: {

            /**
             * 
             */
            defaultGroup: {
                type: String,
                default: 'Módulos',
            },

            /**
             * 
             */
            items: Array,
        }
    }
</script>
